var UtilCache = {
  identifier: null,
}

var Util = {
  validarCNPJ: function (cnpj) {
    // 1. Ajuste na limpeza: agora permite letras (A-Z) e números (0-9)
    cnpj = cnpj.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

    if (!cnpj || cnpj.length !== 14) return false;

    // 2. Blacklist (mantida para compatibilidade com legados numéricos)
    const blacklist = [
      "00000000000000", "11111111111111", "22222222222222", "33333333333333",
      "44444444444444", "55555555555555", "66666666666666", "77777777777777",
      "88888888888888", "99999999999999"
    ];
    if (blacklist.includes(cnpj)) return false;

    // Função auxiliar para o cálculo do Módulo 11 Alfanumérico
    const calcularDV = (base) => {
      let soma = 0;
      let peso = (base.length - 7); // Lógica de peso dinâmico (5 ou 6 inicial)

      for (let i = 0; i < base.length; i++) {
        // REGRA OURO: Valor ASCII do caractere menos 48
        const valor = base.charCodeAt(i) - 48;

        soma += valor * peso--;
        if (peso < 2) peso = 9;
      }

      const resto = soma % 11;
      return resto < 2 ? 0 : 11 - resto;
    };

    // 3. Validação do Primeiro Dígito
    const basePrimeiroDV = cnpj.substring(0, 12);
    const primeiroDVCalculado = calcularDV(basePrimeiroDV);
    if (primeiroDVCalculado !== parseInt(cnpj.charAt(12))) return false;

    // 4. Validação do Segundo Dígito
    const baseSegundoDV = cnpj.substring(0, 13);
    const segundoDVCalculado = calcularDV(baseSegundoDV);
    if (segundoDVCalculado !== parseInt(cnpj.charAt(13))) return false;

    return true;
  },
  validaCPF: function (strCPF) {
    var Soma;
    var Resto;
    Soma = 0;
    if (strCPF == "00000000000") return false;

    for (i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11)) Resto = 0;
    if (Resto != parseInt(strCPF.substring(9, 10))) return false;

    Soma = 0;
    for (i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11)) Resto = 0;
    if (Resto != parseInt(strCPF.substring(10, 11))) return false;
    return true;
  },

  mascara: function (m, t, e, c) {
    var cursor = t.selectionStart;
    var id = e.keyCode || e.which;
    var livre = (id == 16 || id == 19 || (id >= 33 && id <= 40));

    if (livre) return;

    // Se for Backspace, deixa o navegador agir normalmente
    if (id == 8) return;

    // Colar: Ctrl+V / Cmd+V — deixa colar e aplica máscara depois
    if ((e.ctrlKey || e.metaKey) && (e.key === 'v' || e.key === 'V')) {
      setTimeout(function() {
        var aceitaLetras = m.indexOf('A') !== -1;
        var textoLimpo = aceitaLetras
          ? t.value.replace(/[^a-zA-Z0-9]/g, '')
          : t.value.replace(/\D/g, '');

        var resultado = "";
        var j = 0;

        for (var i = 0; i < m.length && j < textoLimpo.length; i++) {
          var mChar = m.charAt(i);
          var tChar = textoLimpo.charAt(j);

          if (mChar === "A" || mChar === "#") {
            if (mChar === "#" && !/[0-9]/.test(tChar)) {
              j++; i--; continue;
            }
            resultado += tChar.toUpperCase();
            j++;
          } else {
            resultado += mChar;
          }
        }

        t.value = resultado;
        t.setSelectionRange(resultado.length, resultado.length);
        if (c) coresMask(t);
      }, 0);
      return;
    }

    // Demais atalhos Ctrl/Cmd ficam com o navegador (evita tratar "Control" como texto)
    if (e.ctrlKey || e.metaKey) return;

    if (e.key.length > 1) return;

    // Cancela o evento padrão para tomarmos controle total da digitação
    if (e.preventDefault) e.preventDefault();

    // correção numpad
    var tecla = e.key;

    // 1. Pega o que já tinha no campo + a tecla nova
    var textoCompleto = t.value.slice(0, t.selectionStart) + tecla + t.value.slice(t.selectionEnd);

    // 2. Limpeza: se a máscara tem 'A', permite letras
    var aceitaLetras = m.indexOf('A') !== -1;
    var textoLimpo = aceitaLetras
      ? textoCompleto.replace(/[^a-zA-Z0-9]/g, '')
      : textoCompleto.replace(/\D/g, '');

    var resultado = "";
    var j = 0;

    // 3. Loop de montagem síncrona
    for (var i = 0; i < m.length && j < textoLimpo.length; i++) {
      var mChar = m.charAt(i);
      var tChar = textoLimpo.charAt(j);

      if (mChar === "A" || mChar === "#") {
        if (mChar === "#" && !/[0-9]/.test(tChar)) {
          j++; i--; continue;
        }
        resultado += tChar.toUpperCase();
        j++;
      } else {
        resultado += mChar;
      }
    }

    t.value = resultado;

    // 4. Reposiciona o cursor logicamente
    var novoCursor = resultado.length;
    t.setSelectionRange(novoCursor, novoCursor);

    if (c) coresMask(t);
  },

  validateEmail: function (email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  },

  getIdentifier() {
    const host = window.location.host;
    const ipPattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

    if (host === 'localhost' || ipPattern.test(host.split(':')[0])) {
      if (UtilCache.identifier) {
        return UtilCache.identifier;
      }
      UtilCache.identifier = prompt('Informe o itentificador:');
      return UtilCache.identifier;
    }
    return window.location.host.split('.')[0];
  },

  formatPhoneNumber(phoneNumber) {
    phoneNumber = phoneNumber.replace(/\D/g, '');

    // Apply the phone number mask for 10-digit and 11-digit numbers
    if (phoneNumber.length === 10) {
      return phoneNumber.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    } else if (phoneNumber.length === 11) {
      return phoneNumber.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    } else {
      return phoneNumber; // Return the original number if it doesn't match expected lengths
    }
  }
};
